import axios from "axios";

export const getWalletByCustomerId = async (customerId) => {
  try {
    const apiUrl = `${process.env.REACT_APP_API_URL}WalletAPI/GetWalletByCustomerId?customerId=${customerId}`;
    const response = await axios.get(apiUrl);

    // ✅ Extract the actual wallet object
    return response.data?.data || null;
  } catch (error) {
    console.error("❌ Wallet API Error:", error);
    throw error;
  }
};
